import StorageServiceRepository from "../../ports/storageServiceRepository";

export type uploadImageUsecase = (
  file: Blob | File,
  fileName: string
) => Promise<string | undefined>;

export const buildUploadImage = (dependencies: {
  storageServiceRepo: StorageServiceRepository;
}): uploadImageUsecase => {
  const { storageServiceRepo } = dependencies;

  const uploadFile: uploadImageUsecase = async (
    file: Blob | File,
    fileName: string
  ) => storageServiceRepo.uploadImage(file, fileName);

  return uploadFile;
};
